import React from 'react'
import { useProductSearchFilters } from './ProductSearchContext'

import { Input, Grid, Row, Col } from 'rsuite'
import ProductSearchFilters from './filters/ProductSearchFilters'

function ProductSearchInput () {
  const {
    currentShopID,
    filterQuery,
    setFilterName,
    setFilterQuery
  } = useProductSearchFilters()

  const handleQueryChange = (value: string) => {
    setFilterName(value)
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={24}>
          <Input
            placeholder="Поисковый запрос"
            value={filterQuery.name}
            onChange={handleQueryChange}
          />
          {currentShopID && (
            <ProductSearchFilters
              shop_id={currentShopID}
              onChange={setFilterQuery}
            />
          )}
        </Col>
      </Row>
    </Grid>
  )
}

export default ProductSearchInput
